export default __webpack_public_path__ + "static/media/upcoming_30_blue.a732908a.svg";